<template>
  <div id="catalogEdit">
    <Panel :title="$t('display_priority')">
      <Draggable v-model="companies" @start="drag=true" @end="drag=false">
        <div v-for="company of companies" class="item-line">
          <svgicon src="icon/hamburger.svg" :height="12" :width="12"></svgicon>
          <span>{{company.name}}</span>
        </div>
      </Draggable>
    </Panel>
    <div class="footer-actions">
      <button class="btn btn-primary" @click="save">{{$t("save")}}</button>
    </div>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable';
  import { Core } from "@/core/Core";

  export default {
    name: "CompanyPriority",

    components: { Draggable },

    data() {
      return {
        branch: null,
        ready: false,
        companies: []
      }
    },

    async mounted() {
      let branch = this.$route.query.branch;
      this.branch = this.$route.query.branch;
      this.$store.commit('showSpinner', true);
      this.companies = await Core.request("GET", '/api/entity/company/select', {branch, add: 'priority'});
      this.companies.sort((a1, a2) => a1.priority === a2.priority ? 0 : (a1.priority < a2.priority ? -1 : 1));
      this.$store.commit('showSpinner', false);
    },

    methods: {
      async save() {
        let payload = this.companies.map((c, i) => ({id: c.id, priority: i}));
        let response = await Core.request('PUT', `/api/branches/${this.branch}/update-company-priority`, payload);
        if (response) {
          toast(this.$t('success'), 'success');
        } else {
          toast(this.$t('error.no_server'), 'error');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.item-line {
  background-color: #f2f2f2;
  margin: 5px 0;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: grab;
  max-width: 900px;

  label {
    flex-grow: 1;
  }

  .svgicon {
    fill: #ccc;
    margin-right: 20px;
  }

  .tag {
    text-transform: none;
    font-weight: normal;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 14px;
  }
}
</style>